<template>
    <div class="card shadow">
        <div class="card-body">
            <div class="card shadow md-4">
                <div class="card-body">
                    <div class="mb-3">
                        <heading-icon :title="$t('STEPS')" icon="question" :pointerCursor="true" @click="$bvModal.show('category-info-modal')"/>
                        <hr>
                    </div>
                    <div v-for="(categoryStep,index) in category.steps" :key="index" class="mb-3">
                        <router-link :to="`/categories/${$route.params.id}/steps/${categoryStep.id}`">
                            <button v-if="checkIfStepLast(index)" class="darker-danger-background btn btn-danger">
                                <icon icon="check-circle" />
                            </button>
                            <button v-else-if="index === 0" class="darker-danger-background btn btn-danger">
                                <icon icon="play"/>
                            </button>
                            <button v-else class="darker-danger-color darker-danger-broder btn btn-outline-danger color-red border-red">
                                <icon icon="play" />
                            </button>
                        </router-link>
                         
                        <span class="col-3">{{ categoryStep.title }}</span>
                        <span v-if="progressLogs.map(function(item) { return item.stepId; }).indexOf(categoryStep.id) >= 0">
                            {{progressLogs[progressLogs.map(function(item) { return item.stepId; }).indexOf(categoryStep.id)].dateTime.replace('T', ' ').slice(0,19)}}
                        </span>
                        <span class="status-icon">
                            <icon v-if="getCategoryStepStatus(categoryStep.id) == 1" class="ml-2 status-treatment" icon='exclamation'/>
                            <icon v-else-if="getCategoryStepStatus(categoryStep.id) == 2" class="ml-2 status-success" icon="check" />
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="category-info-modal" hide-footer>
            <template v-slot:modal-title>
                <h6 class="m-0 text-primary">{{ category.title }}</h6>
            </template>
            <div class="d-block text-center">
                <div class="form-group col-12" v-dompurify-html="category.description"></div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import HeadingIcon from "../misc/HeadingIcon";

export default {
    data() {
        return {
            category:{},
            progressLogs: [],
            categoryStepStatuses: [],
            stepIds: [],              
        }
    },
    components: {
        HeadingIcon
    },
    computed: {
        cgaPatientSheet: function() {
            return this.$store.getters.cgaPatientSheet;
        },
        categoryId: function() {
            return this.$route.params.id
        },
        stepSequences: function() {
            return this.$store.getters.stepSequences;
        }
    },
    methods: {
        loadCategoryWithSteps: function(categoryId) {
            let self = this;
            this.$http.get('/api/categories/get-with-steps/' + categoryId)
            .then(response => {
                self.category = response.data;

                self.stepIds = [];
                self.category.steps.forEach(element => {
                    self.stepIds.push(element.id);
                });
                self.loadCategoryStepSequencesForGivenSteps(self.stepIds);
                
            })
            .catch(error => {
                console.log(error);
                //self.$router.push("/404");
            })
        },
        loadCategoryStepSequencesForGivenSteps: function(stepIds) {
            let self = this;
            this.$store.dispatch('loadCategoryStepSequencesForGivenSteps', stepIds)
                .then(response => {
                    //console.log(response);
                })
                .catch(error => {
                    console.log(error);
                    //self.$router.push("/404");
                });
        },            
        loadProgressLogsPerCategory: function() {
            let self = this;
            this.$http.get(`/api/categories/${this.categoryId}/progress-logs/get-per-sheet/${this.cgaPatientSheet.id}`)
            .then(response => {
                self.progressLogs = response.data;
            })
            .catch(error => {
                console.log(error);
            })
        },
        loadAllCategoryStatuses: function() {
            let self = this;
            this.$http.get(`/api/category-steps/statuses/${this.cgaPatientSheet.id}`)
            .then(response => {
                self.categoryStepStatuses = response.data;
            })
            .catch(error => {
                console.log(error);
            })
        },
        getCategoryStepStatus: function(categoryStepId)
        {
            if(this.categoryStepStatuses.length > 0)
            {
                var statusIndex = this.categoryStepStatuses.map(function (item) {return item.categoryStepId}).indexOf(categoryStepId)
                return this.categoryStepStatuses[statusIndex].status;
            }
        },
        checkIfStepLast(index) {
            return this.category.steps.length === index + 1; 
        }
    },
    mounted: function () {
        this.loadCategoryWithSteps(this.categoryId);
        if (this.cgaPatientSheet != null) { // On mount if cgaPatientSheet is loaded
            this.loadProgressLogsPerCategory(); 
            this.loadAllCategoryStatuses();
        }
    },
    watch: {
        categoryId: function(val) // On route change in /categories/
        {
            this.loadCategoryWithSteps(val);
            this.loadProgressLogsPerCategory();
            this.loadAllCategoryStatuses();
        },
        cgaPatientSheet: function(val) // When cgaPatientSheet loads
        {
            if (this.cgaPatientSheet != null){
                this.loadProgressLogsPerCategory();
                this.loadAllCategoryStatuses();
            }
        }
        
    }
}
</script>
<style lang="scss" scoped>
.status-container {
    span {
        &.status-icon {
            svg{
                border-radius: 50%;
                width: 20px;
                height: 20px;
                padding: 2px;
            }
            color: white;
            .status-success {
                background: #1cc88a;
                border: 1px solid #14aa73;
            }
            .status-treatment{
                background: #f52323;
                border: 1px solid #cc1414;
            }
        }
    }
}
.color-red {
    color: red;
    &:hover {
        color: red;
    }
}
.border-red {
    border: 1.5px solid red;
    &:hover {
        border: 1.5px solid red;
    }
}
</style>